export const getRandomID = () => {
  return Math.floor(Math.random() * 10000);
};

export const debounce = (func: any, timeout = 500) => {
  let timer: any;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
};
export const dataURLtoBlob = (dataURL: any, fileName: string) => {
  let arr = dataURL.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const blob = new Blob([u8arr], { type: mime });
  (blob as any).name = fileName; // Set the name property directly
  return blob;
};

export const fileConversionToBlob = (
  file: File,
  callback: (blob: Blob) => void
) => {
  const reader = new FileReader();

  reader.onload = (e: any) => {
    const dataURL = e.target.result;
    const blob = dataURLtoBlob(dataURL, file.name);
    callback(blob);
    // Send the Blob to the server
  };
  reader.readAsDataURL(file);
};

export const convertToObject = (obj: any) => {
  const result: any = {};

  for (const key in obj) {
    const keys = key.split(".");
    let currentLevel = result;

    for (let i = 0; i < keys.length; i++) {
      const currentKey = keys[i];
      if (!currentLevel[currentKey]) {
        if (i === keys.length - 1) {
          currentLevel[currentKey] = obj[key];
        } else {
          currentLevel[currentKey] = {};
        }
      } else if (i === keys.length - 1) {
        currentLevel[currentKey] = obj[key];
      }

      currentLevel = currentLevel[currentKey];
    }
  }

  return result;
};

// export const convertToObject = (obj: any) => {
//   const result: any = {};

//   const processKey = (keys: string[], value: any) => {
//     let currentLevel = result;

//     for (let i = 0; i < keys.length; i++) {
//       const currentKey = keys[i];
//       const isArrayKey = /\d+/.test(currentKey);

//       if (isArrayKey) {
//         const arrayIndex = parseInt(currentKey, 10);
//         if (!Array.isArray(currentLevel)) {
//           currentLevel = [];
//         }
//         while (currentLevel.length <= arrayIndex) {
//           currentLevel.push({});
//         }

//         if (i === keys.length - 1) {
//           currentLevel[arrayIndex] = value;
//         } else {
//           currentLevel[arrayIndex] = currentLevel[arrayIndex] || {};
//         }
//       } else {
//         if (!currentLevel[currentKey]) {
//           if (i === keys.length - 1) {
//             currentLevel[currentKey] = value;
//           } else {
//             currentLevel[currentKey] = {};
//           }
//         } else if (i === keys.length - 1) {
//           currentLevel[currentKey] = {
//             ...currentLevel[currentKey],
//             [currentKey]: value,
//           };
//         }

//         currentLevel = currentLevel[currentKey];
//       }
//     }
//   };

//   for (const key in obj) {
//     const keys = key.split(".");
//     processKey(keys, obj[key]);
//   }

//   return result;
// };

export function replaceObjectWithValueId(obj: any) {
  // Check if the object is not null and is of type object
  if (obj && typeof obj === "object" && !Array.isArray(obj)) {
    // If the object has an 'id' property, return the i
    // If it doesn't have an 'id' property, iterate over its keys
    for (let key in obj) {
      if (Array.isArray(obj[key])) break;
      // If the value of the key is an object, call replaceObjectWithValueId recursively
      if (typeof obj[key] === "object" && key.toLowerCase().includes("id")) {
        obj[key] = replaceObjectWithValueId(obj[key]?.id) || null;
      } else if (typeof obj[key] === "object") {
        obj[key] = replaceObjectWithValueId(obj[key]);
      }
    }
  }
  return obj;
}
export function calculateReadTime(article: string = "", wordsPerMinute = 250) {
  const words = article.split(" ").length;
  const readTime = Math.ceil(words / wordsPerMinute);
  return readTime;
}

export function deepClone(obj: any): any {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  let clone: any;
  if (Array.isArray(obj)) {
    clone = [];
    for (let i = 0; i < obj.length; i++) {
      clone[i] = deepClone(obj[i]);
    }
  } else {
    clone = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = deepClone(obj[key]);
      }
    }
  }

  return clone;
}

export function isValidString(str: string) {
  const regex = /^[a-zA-Z0-9-]+$/;
  return regex.test(str);
}

export function InsertElementAt(array: any[], index: number, element: any) {
  if (!Array.isArray(array)) {
    throw new Error("The first argument must be an array");
  }

  // Make a shallow copy of the original array
  let resultArray = array.slice();

  // Insert the element at the specified index
  resultArray.splice(index, 0, element);

  return resultArray;
}

export function RemoveElementAt(array: any[], index: number) {
  if (!Array.isArray(array)) {
    throw new Error("The first argument must be an array");
  }
  // Make a shallow copy of the original array
  let resultArray = array.slice();

  // Remove the element at the specified index
  resultArray.splice(index, 1);

  return resultArray;
}

// Convert Date Function
export const convertDate = (date = "") => {
  const dateFormat = new Date();
  const year = dateFormat.getFullYear();
  const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11
  const day = String(dateFormat.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};


